import PropTypes from 'prop-types';

import ModuleContainer from '../components/ModuleContainer';
import Link from '../components/Link';

import './Linking.scss';

const SEPARATOR = ':::';

const linkToString = ({ url, anchorText }) => [url, anchorText].join(SEPARATOR);
const stringToLink = str => {
  const [url, anchorText] = str.split(SEPARATOR);
  return { url, anchorText };
};

const cleanDuplicatedLinks = links => {
  const stringifiedLinks = links.map(linkToString);

  const uniqueLinks = new Set(stringifiedLinks);

  return Array.from(uniqueLinks).map(stringToLink);
};

const LinkingTitle = ({ hasMainTitle = false, title }) =>
  hasMainTitle ? (
    <h3 className="linking-subtitle">{title}</h3>
  ) : (
    <h2 className="linking-title">{title}</h2>
  );

LinkingTitle.propTypes = {
  hasMainTitle: PropTypes.bool,
  title: PropTypes.string.isRequired
};

const LinkingSection = ({ links, hasMainTitle = false, title = '' }) => (
  <section className="linking-section">
    {title && <LinkingTitle title={title} hasMainTitle={hasMainTitle} />}
    <div className="linking-container">
      {cleanDuplicatedLinks(links).map(({ url, anchorText }) => (
        <Link key={`${url}_${anchorText}`} href={url}>
          {anchorText}
        </Link>
      ))}
    </div>
  </section>
);

LinkingSection.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      anchorText: PropTypes.string
    })
  ).isRequired,
  hasMainTitle: PropTypes.bool,
  title: PropTypes.string
};

const Linking = ({ highlighted = false, title = '', linkingSections = [] }) =>
  !!linkingSections.length && (
    <ModuleContainer highlighted={highlighted}>
      {title && <h2 className="linking-title">{title}</h2>}
      {linkingSections.map(section => (
        <LinkingSection
          {...section}
          key={`${title}_${section.title}`}
          hasMainTitle={!!title}
        />
      ))}
    </ModuleContainer>
  );

Linking.propTypes = {
  highlighted: PropTypes.bool,
  title: PropTypes.string,
  linkingSections: PropTypes.arrayOf(PropTypes.shape(LinkingSection.propTypes))
    .isRequired
};

export default Linking;
